import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { AbBannerProvider } from "abreact/app/banner/AbBannerProvider";
import { AbDefaultThemingService } from "abreact/app/theming/AbDefaultThemingService";
import { LogUtils } from "abweb/utils/log/LogUtils";
export class AbReactServices {
  static resetServices() {
    AbReactServices.singleton = undefined;
  }

  /**
   * Only application initialization error handling logic should ever need this to reason how far
   * app loading got before throwing.
   */
  static isInitialized() {
    return AbReactServices.singleton != null;
  }
  constructor(BannerProvider = new AbBannerProvider(), AbThemingService = new AbDefaultThemingService(), pageStateManager) {
    _defineProperty(this, "_AbBannerProvider", void 0);
    _defineProperty(this, "_AbThemingService", void 0);
    _defineProperty(this, "_PageStateManager", void 0);
    if (AbReactServices.singleton) {
      // Get hard to debug test failures if multiple AbReactService instances are live, so fail hard
      const errMsg = "Already initialized AbReactServices.  Call AbReactServices.resetServices before re-initializing.";
      AbReactServices.LOG.error(errMsg);
      throw new Error(errMsg);
    }
    this._AbBannerProvider = BannerProvider;
    this._AbThemingService = AbThemingService;
    this._PageStateManager = pageStateManager;
    AbReactServices.singleton = this;
  }
  static getPageStateManager() {
    return AbReactServices.singleton._PageStateManager;
  }
  static get bannerProvider() {
    return AbReactServices.singleton._AbBannerProvider;
  }
  static get themingService() {
    return AbReactServices.singleton._AbThemingService;
  }
}
_defineProperty(AbReactServices, "LOG", LogUtils.getLogger(__filename));
_defineProperty(AbReactServices, "singleton", void 0);
//# sourceMappingURL=AbReactServices.js.map
